/**
 * Validates that a checkbox is checked.
 */
export const Validator = {
    name: "required_checkbox",
    isImplicit: true,
    errorMessage: "You should select at least one of the options.",
    validate: value => value !== undefined && value !== null && value !== "",
};
